"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _filterChildren = _interopRequireDefault(require("../../../utils/Children/filterChildren"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CardText = function CardText(props) {
  var id = props.id,
    className = props.className,
    expanded = props.expanded,
    expandable = props.expandable,
    style = props.style,
    containerStyle = props.containerStyle;
  var cardTextClass = function cardTextClass() {
    return (0, _classnames["default"])({
      'ui-card-text': true,
      'ui-card-text--hidden': !expanded && expandable,
      'ui-card-text--expanded': expanded || !expandable
    }, className);
  };
  var newChildren = (0, _filterChildren["default"])(props.children);
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    className: cardTextClass(),
    style: style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-card-text__container",
    style: containerStyle
  }, newChildren));
};
CardText.propTypes = {
  /** id for reference */
  id: _propTypes["default"].string,
  /** className for reference */
  className: _propTypes["default"].string,
  /** Override the inline-styles of the root element || Not Recommended */
  style: _propTypes["default"].object,
  /** Override the inline-styles of the contaier element || Not Recommended */
  containerStyle: _propTypes["default"].object,
  /**
   * If true, this card component is controlled.
   * @ignore
   */
  expandable: _propTypes["default"].bool,
  /**
   * If true, this card component is expanded (uncontrolled)
   * @ignore
   */
  expanded: _propTypes["default"].bool,
  /**
  * children props for content inside
  * @ignore
  */
  children: _propTypes["default"].node
};
CardText.defaultProps = {
  id: '',
  className: '',
  expanded: null,
  expandable: false,
  children: [],
  style: {},
  containerStyle: {}
};
var _default = CardText;
exports["default"] = _default;